// ─── SuperAdmin Dashboard — Hardcoded Mock Data ──────────────────────────────
// All data is realistic and structured to match the real API shapes used in
// the existing dashboard. Replace each section's fetch with the real API call.

// ── KPI Totals ────────────────────────────────────────────────────────────────
export const kpiTotals = {
  totalCompanies: 42,
  totalPages: 318,
  totalCompanyGroups: 8,
  totalUsers: 274,
  totalEmployees: 189,
  totalParties: 156,
};

// ── POS Data ──────────────────────────────────────────────────────────────────
export const posData = {
  totalPosSale: 18_74_320.5,
  totalSaleTransactions: 4821,

  machines: {
    total: 64,
    active: 41,
    inactive: 9,
    expired: 7,
    empty: 3,
    updated: 38,
    nonUpdated: 26,
    usagePercent: 64,
  },

  franchiseLeaderboard: [
    { rank: 1, name: "Mumbai Central Franchise", sale: 3_42_800, transactions: 920, growth: 12.4 },
    { rank: 2, name: "Pune West Franchise", sale: 2_98_500, transactions: 812, growth: 8.1 },
    { rank: 3, name: "Delhi NCR Franchise", sale: 2_54_100, transactions: 701, growth: 5.6 },
    { rank: 4, name: "Hyderabad South", sale: 1_87_650, transactions: 543, growth: -2.3 },
    { rank: 5, name: "Chennai Franchise", sale: 1_64_200, transactions: 489, growth: 3.9 },
    { rank: 6, name: "Ahmedabad East", sale: 1_42_900, transactions: 421, growth: 7.2 },
    { rank: 7, name: "Bengaluru North", sale: 1_18_320, transactions: 388, growth: 1.8 },
    { rank: 8, name: "Kolkata Central", sale: 98_750, transactions: 312, growth: -1.1 },
  ],

  dailySaleTrend: [
    { date: "Jun 19", amount: 62_400 },
    { date: "Jun 20", amount: 58_200 },
    { date: "Jun 21", amount: 71_800 },
    { date: "Jun 22", amount: 49_100 },
    { date: "Jun 23", amount: 83_600 },
    { date: "Jun 24", amount: 91_200 },
    { date: "Jun 25", amount: 74_500 },
  ],
};

// ── Purchase Orders ───────────────────────────────────────────────────────────
export const purchaseData = {
  modules: [
    { module: "Raw Material", orders: 312, amount: 28_45_600, pending: 48, approved: 241, rejected: 23 },
    { module: "Packaging", orders: 198, amount: 12_32_800, pending: 31, approved: 154, rejected: 13 },
    { module: "Machinery Parts", orders: 87, amount: 19_84_200, pending: 12, approved: 68, rejected: 7 },
    { module: "Consumables", orders: 143, amount: 6_41_300, pending: 22, approved: 112, rejected: 9 },
    { module: "IT Equipment", orders: 54, amount: 8_92_100, pending: 8, approved: 42, rejected: 4 },
  ],
  totalOrders: 794,
  totalAmount: 75_96_000,
  pendingOrders: 121,
  approvedOrders: 617,
  rejectedOrders: 56,
};

// ── ERP Sale ──────────────────────────────────────────────────────────────────
export const erpSaleData = {
  modules: [
    { module: "Retail ERP", bills: 2841, amount: 42_38_900 },
    { module: "Wholesale ERP", bills: 1204, amount: 31_12_400 },
    { module: "B2B Portal", bills: 642, amount: 18_74_100 },
    { module: "Direct Sales", bills: 389, amount: 9_28_600 },
    { module: "Export Division", bills: 118, amount: 12_64_800 },
  ],
  totalBills: 5194,
  totalAmount: 1_14_18_800,
};

// ── Most / Least Sold Items ───────────────────────────────────────────────────
export const itemSaleData = {
  mostSold: [
    { rank: 1, item: "Masala Chai Premix 1kg", qty: 8420, amount: 12_63_000, category: "Beverages" },
    { rank: 2, item: "Ginger Lemon Syrup 500ml", qty: 6210, amount: 9_31_500, category: "Beverages" },
    { rank: 3, item: "Filter Coffee Blend 500g", qty: 5880, amount: 8_82_000, category: "Beverages" },
    { rank: 4, item: "Dry Fruit Mix 250g", qty: 4940, amount: 11_85_600, category: "Snacks" },
    { rank: 5, item: "Cardamom Powder 100g", qty: 4120, amount: 4_94_400, category: "Spices" },
  ],
  leastSold: [
    { rank: 1, item: "Saffron 2g Pack", qty: 38, amount: 15_200, category: "Spices" },
    { rank: 2, item: "Truffle Salt 50g", qty: 52, amount: 7_280, category: "Seasonings" },
    { rank: 3, item: "Star Anise Whole 100g", qty: 71, amount: 4_970, category: "Spices" },
    { rank: 4, item: "Mace Powder 50g", qty: 84, amount: 5_040, category: "Spices" },
    { rank: 5, item: "Vanilla Extract 30ml", qty: 98, amount: 8_820, category: "Essentials" },
  ],
};

// ── Production ────────────────────────────────────────────────────────────────
export const productionData = {
  totalBatches: 284,
  completedBatches: 261,
  inProgressBatches: 18,
  failedBatches: 5,

  wastage: {
    totalKg: 1248.6,
    percentOfProduction: 4.8,
    byCategory: [
      { category: "Mixing Stage", kg: 412.4, percent: 33.0 },
      { category: "Packaging Loss", kg: 318.2, percent: 25.5 },
      { category: "Quality Reject", kg: 284.6, percent: 22.8 },
      { category: "Raw Material", kg: 233.4, percent: 18.7 },
    ],
  },

  stock: [
    { item: "Masala Chai Premix", inStock: 4200, reorderLevel: 1000, unit: "kg", status: "OK" },
    { item: "Ginger Syrup Base", inStock: 380, reorderLevel: 500, unit: "L", status: "Low" },
    { item: "Filter Coffee Blend", inStock: 2100, reorderLevel: 800, unit: "kg", status: "OK" },
    { item: "Cardamom Powder", inStock: 120, reorderLevel: 200, unit: "kg", status: "Critical" },
    { item: "Packaging Boxes", inStock: 8400, reorderLevel: 2000, unit: "pcs", status: "OK" },
  ],

  productionVsSale: [
    { month: "Jan", produced: 24200, sold: 21800 },
    { month: "Feb", produced: 26400, sold: 24100 },
    { month: "Mar", produced: 28100, sold: 27300 },
    { month: "Apr", produced: 31200, sold: 28900 },
    { month: "May", produced: 29800, sold: 30100 },
    { month: "Jun", produced: 22100, sold: 19400 },
  ],

  materialIssueInsights: {
    totalIssued: 342,
    pendingApproval: 28,
    approved: 298,
    rejected: 16,
    topIssuedMaterials: [
      { material: "Masala Blend Base", qty: 8400, unit: "kg" },
      { material: "Sugar", qty: 6200, unit: "kg" },
      { material: "Ginger Extract", qty: 2100, unit: "L" },
      { material: "Cardamom Seeds", qty: 1840, unit: "kg" },
      { material: "Packaging Film", qty: 14200, unit: "m" },
    ],
  },
};

// ── Users & Parties ───────────────────────────────────────────────────────────
export const userPartyData = {
  users: {
    total: 274,
    active: 218,
    inactive: 56,
    neverLoggedIn: 31,
    loggedInToday: 94,
    mobileOnly: 84,
    emailOnly: 112,
    both: 62,
    neither: 16,
    byRole: [
      { role: "Admin", count: 18 },
      { role: "Manager", count: 47 },
      { role: "Operator", count: 89 },
      { role: "Viewer", count: 63 },
      { role: "Super Admin", count: 4 },
      { role: "Accountant", count: 53 },
    ],
  },
  parties: {
    total: 156,
    active: 134,
    inactive: 22,
    byType: [
      { type: "Distributor", count: 48 },
      { type: "Retailer", count: 62 },
      { type: "Supplier", count: 28 },
      { type: "Franchise", count: 18 },
    ],
  },
};

// ── Module Usage ──────────────────────────────────────────────────────────────
export const moduleUsageData = {
  mostUsed: [
    { module: "POS Billing", hits: 48_210, avgDailyUsers: 142 },
    { module: "Sales Dashboard", hits: 31_840, avgDailyUsers: 98 },
    { module: "Party Master", hits: 24_600, avgDailyUsers: 71 },
    { module: "Purchase Orders", hits: 18_920, avgDailyUsers: 54 },
    { module: "Inventory Stock", hits: 14_380, avgDailyUsers: 43 },
  ],
  leastUsed: [
    { module: "Export Compliance", hits: 284, avgDailyUsers: 2 },
    { module: "Machine Audit Log", hits: 412, avgDailyUsers: 3 },
    { module: "Batch Certificate", hits: 598, avgDailyUsers: 4 },
    { module: "Currency Master", hits: 641, avgDailyUsers: 3 },
    { module: "SMS Template Config", hits: 782, avgDailyUsers: 5 },
  ],
  weeklyUsage: [
    { day: "Mon", sessions: 1240 },
    { day: "Tue", sessions: 1380 },
    { day: "Wed", sessions: 1520 },
    { day: "Thu", sessions: 1290 },
    { day: "Fri", sessions: 1640 },
    { day: "Sat", sessions: 820 },
    { day: "Sun", sessions: 310 },
  ],
};

// ── Database & API Health ─────────────────────────────────────────────────────
export const systemHealthData = {
  database: {
    sizeMB: 14_820,
    uptimePercent: 99.94,
    lastBackup: "2026-06-25 03:00 AM",
    tableCount: 312,
    slowQueryCount: 7,
    connectionPool: { used: 28, max: 100 },
  },
  api: {
    uptimePercent: 99.87,
    avgResponseMs: 218,
    totalCallsToday: 84_210,
    errorRate: 0.43,
    endpointHealth: [
      { endpoint: "/api/pos/sale", status: "OK", avgMs: 142 },
      { endpoint: "/api/purchase/order", status: "OK", avgMs: 198 },
      { endpoint: "/api/inventory/stock", status: "Slow", avgMs: 842 },
      { endpoint: "/api/reports/export", status: "OK", avgMs: 321 },
      { endpoint: "/api/user/auth", status: "OK", avgMs: 89 },
    ],
  },
};

// ── Server Consumption ────────────────────────────────────────────────────────
export const serverData = {
  cpu: { usedPercent: 34, cores: 16 },
  ram: { usedGB: 22.4, totalGB: 64 },
  storage: {
    usedGB: 842,
    totalGB: 2000,
    breakdown: [
      { label: "Database", gb: 422 },
      { label: "Media/Files", gb: 218 },
      { label: "Logs", gb: 142 },
      { label: "Backups", gb: 60 },
    ],
  },
  recentLogs: [
    { time: "10:42 AM", level: "WARN", message: "High memory usage on node-2 (84%)" },
    { time: "09:18 AM", level: "INFO", message: "Scheduled backup completed — 14.2 GB" },
    { time: "08:54 AM", level: "ERROR", message: "API timeout on /api/inventory/stock (3.2s)" },
    { time: "07:30 AM", level: "INFO", message: "Daily cron: log rotation complete" },
    { time: "Jun 24", level: "ALERT", message: "Large export: 248MB CSV by user ramesh@corp.com" },
    { time: "Jun 24", level: "ALERT", message: "Large export: 186MB PDF by user admin@pune.com" },
  ],
  bigExportAlerts: [
    { user: "ramesh@corp.com", file: "AllSales_June2026.csv", sizeMB: 248, time: "Yesterday 6:12 PM" },
    { user: "admin@pune.com", file: "PurchaseReport_Q2.pdf", sizeMB: 186, time: "Yesterday 4:40 PM" },
    { user: "accounts@hq.in", file: "EmployeePayroll_2025.xlsx", sizeMB: 134, time: "Jun 23 2:10 PM" },
  ],
};

// ── Failed Logins ─────────────────────────────────────────────────────────────
export const securityData = {
  failedLoginsToday: 38,
  failedLoginsThisWeek: 214,
  lockedAccounts: 4,
  suspiciousIPs: 3,
  recentFailures: [
    { time: "10:54 AM", user: "mohan.sales@company.in", ip: "103.21.45.12", reason: "Wrong password" },
    { time: "10:31 AM", user: "unknown_user_42", ip: "198.51.100.18", reason: "User not found" },
    { time: "09:48 AM", user: "admin@hq.com", ip: "45.33.12.8", reason: "Account locked" },
    { time: "09:12 AM", user: "priya.hr@company.in", ip: "192.168.1.42", reason: "Wrong password" },
    { time: "08:30 AM", user: "unknown_user_99", ip: "185.220.101.4", reason: "Blocked IP" },
    { time: "Jun 24", user: "suresh@franchise.com", ip: "103.21.45.12", reason: "Wrong password" },
  ],
  failedByHour: [
    { hour: "12AM", count: 2 },
    { hour: "3AM", count: 8 },
    { hour: "6AM", count: 3 },
    { hour: "9AM", count: 7 },
    { hour: "12PM", count: 6 },
    { hour: "3PM", count: 5 },
    { hour: "6PM", count: 4 },
    { hour: "9PM", count: 3 },
  ],
};

// ── Top Selling Companies ─────────────────────────────────────────────────────
export const topSellingCompanies = [
  { rank: 1, name: "Spice World Pvt Ltd", sale: 48_42_100, growth: 14.2, badge: "Top" },
  { rank: 2, name: "Mumbai Beverages Co.", sale: 38_21_800, growth: 9.8, badge: null },
  { rank: 3, name: "Pune Agro Exports", sale: 31_14_600, growth: 6.4, badge: null },
  { rank: 4, name: "Delhi FMCG Distributors", sale: 27_82_300, growth: -2.1, badge: null },
  { rank: 5, name: "Hyderabad Fresh Foods", sale: 22_44_700, growth: 11.3, badge: null },
];

// ── Exception / Transaction Logs ──────────────────────────────────────────────
export const recentLogs = [
  { id: 1, Transactiontime: "2026-06-25T10:54:00", UserName: "mohan.sales", TransactionType: "Exception", TransactionDetails: "NullReferenceException: Object reference not set", IPaddress: "192.168.1.10" },
  { id: 2, Transactiontime: "2026-06-25T10:42:00", UserName: "priya.hr", TransactionType: "Info", TransactionDetails: "User logged in successfully", IPaddress: "192.168.1.22" },
  { id: 3, Transactiontime: "2026-06-25T10:31:00", UserName: "admin", TransactionType: "Exception", TransactionDetails: "TimeoutException: API call exceeded 5000ms", IPaddress: "103.21.45.12" },
  { id: 4, Transactiontime: "2026-06-25T09:48:00", UserName: "suresh.pos", TransactionType: "Info", TransactionDetails: "POS Sale created — ₹2,480", IPaddress: "10.0.0.8" },
  { id: 5, Transactiontime: "2026-06-25T09:12:00", UserName: "ramesh.acc", TransactionType: "Exception", TransactionDetails: "SqlException: Duplicate entry for key 'PRIMARY'", IPaddress: "192.168.1.34" },
  { id: 6, Transactiontime: "2026-06-25T08:54:00", UserName: "divya.mgr", TransactionType: "Info", TransactionDetails: "Purchase Order #PO-2841 approved", IPaddress: "192.168.1.5" },
  { id: 7, Transactiontime: "2026-06-25T08:30:00", UserName: "system", TransactionType: "Exception", TransactionDetails: "IndexOutOfRangeException in ReportGenerator.cs:142", IPaddress: "127.0.0.1" },
  { id: 8, Transactiontime: "2026-06-24T18:12:00", UserName: "anita.sales", TransactionType: "Info", TransactionDetails: "Large export initiated — 248MB CSV", IPaddress: "192.168.1.48" },
];
